import { basicApi } from '../utils/api';

export interface MessageHistoryItem {
  id: number;
  batchId: number;
  itemNo: number;
  correlationId: string;
  requestedType?: string;
  actualType?: string;
  toNumber: string;
  fromNumber?: string;
  renderedText: string;
  dispatchStatus: string;
  deliveryStatus?: string;
  replacement: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface MessageHistoryPage {
  content: MessageHistoryItem[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface MessageHistoryParams {
  pg: number;
  limit: number;
  startDate?: string;
  endDate?: string;
  type?: string;
  deliveryStatus?: string;
  to?: string;
}

export const listMessageHistory = async (params: MessageHistoryParams) =>
  (await basicApi.get<MessageHistoryPage>('/solapi/messages', { params })).data;
